import type { PianoFingeredKey } from "./pianoFingeringEngine";
import type { NoteName } from "./guitarEngine";
import type { ExtendedChordQuality, InversionType, ExplorerFilter } from "./chordEngine";
import { buildChordToneMidis } from "./chordStaffEvents";

/** Teclas del piano coloreadas por grado del acorde (sin mástil). */
export function buildChordKeyboardFingering(
  root: NoteName,
  quality: ExtendedChordQuality,
  inversion: InversionType,
  voicingType: ExplorerFilter["voicingType"]
): PianoFingeredKey[] {
  const tones = buildChordToneMidis(root, quality, inversion, voicingType);
  const fingers: (1 | 2 | 3 | 4 | 5)[] = [1, 3, 5, 2, 4, 5, 1];
  return tones.map((t, i) => ({
    midi: t.midi,
    finger: fingers[i % fingers.length],
    hand: t.midi >= 60 ? "R" : "L",
    degree: t.degree,
    step: t.step,
  }));
}
